"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6995],{

/***/ 86995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BlogPosts_Post; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/uikit/Boxes/Date.tsx





const DateBox = _ref => {
  let {
    day,
    month,
    style
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
    p: 2,
    bg: "primaryGreen.300",
    color: "primaryGreen.900",
    borderRadius: "4",
    position: "absolute",
    top: "1.5rem",
    left: "1.5rem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "primaryGreen.900",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "1.25rem",
      lineHeight: "26px",
      letterSpacing: "0.57px",
      children: day
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "primaryGreen.900",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: "0.2px",
      children: month
    })]
  });
};

/* harmony default export */ var Boxes_Date = (DateBox);
;// CONCATENATED MODULE: ./src/components/BlogPosts/Post.tsx







const Post = _ref => {
  let {
    categories,
    title,
    excerpt,
    image,
    day,
    month,
    href
  } = _ref;
  const cleanCategories = categories.filter(category => category !== 'Noleggio a Lungo Termine');
  const categoriesList = cleanCategories.join(' | ');
  const descriptionLength = Math.round(288 - (categoriesList.length + title.length * 1.5));
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    title: title,
    href: href,
    target: "_blank",
    rel: "noreferrer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      w: "full",
      bg: "baseWhite",
      rounded: "md",
      p: 6,
      borderRadius: 10,
      overflow: "hidden",
      borderColor: "#d9dde1",
      borderWidth: "1px",
      boxShadow: "0 2px 8px 0px rgba(65, 164, 118, 0.12)",
      h: "30rem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        h: "12.5rem",
        mt: -6,
        mx: -6,
        pos: "relative",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          h: "12.5rem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: image,
            alt: title,
            layout: "fill",
            loading: "lazy",
            decoding: "async"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Boxes_Date, {
            day: day,
            month: month
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
        marginTop: "m",
        h: "calc(100% - 11.3rem);",
        overflow: "hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          color: "green.500",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1rem",
          lineHeight: "20.8px",
          letterSpacing: "0.2px",
          textAlign: "left",
          children: categoriesList
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          color: "baseNeutral.700",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.75rem",
          lineHeight: "15.6px",
          letterSpacing: "0.4px",
          textAlign: "left",
          display: "inherit"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h6",
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.375rem",
          lineHeight: "28.6px",
          letterSpacing: "0.57px",
          textAlign: "left",
          marginTop: "m",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "1rem",
          lineHeight: "20.8px",
          letterSpacing: "0.2px",
          textAlign: "left",
          marginTop: ".562rem",
          children: `${excerpt.substring(0, descriptionLength)}...`
        })]
      })]
    })
  });
};

/* harmony default export */ var BlogPosts_Post = (Post);

/***/ })

}]);